export default "__VITE_ASSET__9cj6RSnB__"